<template>
  <div class="card">
    <div class="p-3 card-body">
      <div class="row">
        <h5>{{ title }}</h5>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <mini-statistics-card :title="$t('key_number')" :value="value['items']" :percentage="{
                  value: '+55%',
                  color: 'text-success',
                }" :icon="iconNumero" direction-reverse />
        </div>
        <div class="col-lg-6">
          <mini-statistics-card :title="$t('key_units')" :value="value['units']" :percentage="{
                  value: '+55%',
                  color: 'text-success',
                }" :icon="iconUnit" direction-reverse />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import MiniStatisticsCard from "../../examples/Cards/MiniStatisticsCard.vue";

export default {
  name: "EntitySummaryCard",
  components: {
    MiniStatisticsCard,
  },
  props: {
    title: {
      type: [Object, String],
      default: null,
      text: {
        type: String,
      },
      color: {
        type: String,
      },
    },
    value: {
      type: [Object],
      required: true,
      items: {
        type: [Number],
      },
      units: {
        type: Number,
      },
    },
    iconNumero: {
      type: [String, Object],
      component: {
        type: String,
      },
      background: {
        type: String,
      },
      default: () => ({
        background: "bg-white",
      }),
    },
    iconUnit: {
      type: [String, Object],
      component: {
        type: String,
      },
      background: {
        type: String,
      },
      default: () => ({
        background: "bg-white",
      }),
    },
  },
  data() {
    return {
      iconBackground: "bg-gradient-success",
    };
  },
};
</script>
